import type { UpdateCourseDraft200SectionsItemLecturesItemContentType } from './updateCourseDraft200SectionsItemLecturesItemContentType';
import type { UpdateCourseDraft200SectionsItemLecturesItemPlatformSupport } from './updateCourseDraft200SectionsItemLecturesItemPlatformSupport';

/**
 * 코스 강의(레슨) 정보
 */
export type UpdateCourseDraft200SectionsItemLecturesItem = {
  /** 콘텐츠 타입 */
  contentType: UpdateCourseDraft200SectionsItemLecturesItemContentType;
  /**
   * 강의 시간 (초 단위)
   * @minimum 0
   * @nullable
   */
  duration?: number | null;
  /**
   * 강의 ID (새 강의의 경우 null)
   * @nullable
   */
  id?: string | null;
  /**
   * 마크다운 콘텐츠 (새 강의 생성 시 필수)
contentType이 MARKDOWN 또는 INTERACTIVE인 경우 필수
기존 강의의 마크다운 수정은 별도 API 사용

   * @minLength 1
   * @maxLength 10000
   * @nullable
   */
  markdownContent?: string | null;
  /**
   * 업로드된 마크다운 파일의 URL
   * @nullable
   */
  markdownUrl?: string | null;
  /**
   * 섹션 내 강의 순서 (1부터 시작)
   * @minimum 1
   */
  order: number;
  /** 플랫폼 지원 */
  platformSupport: UpdateCourseDraft200SectionsItemLecturesItemPlatformSupport;
  /**
   * 강의 제목
   * @minLength 1
   * @maxLength 200
   */
  title: string;
  /**
   * 비디오 콘텐츠 URL
   * @nullable
   */
  videoUrl?: string | null;
};
